<app-header mainHeading="Add a new care type" [breadcrumbs]="['System settings', 'Care types', 'Add a new care type']"
            [links]="['/settings/general-information', '/settings/care-types', '/settings/care-types/add']" />

<form (ngSubmit)="addCareType()">
    <main class="add-new-shell">
        <cll-card class="add-new-card">
            <cll-card-header>
                <cll-icon cllCardIcon type="outlined">info</cll-icon>
                <cll-card-title>Basic details</cll-card-title>
            </cll-card-header>

            <div class="add-new-row-container">

                <div>
                    <cll-form-field label="Name" class="w-full">
                        <input cllFormInput [formControl]="careTypeFormGroup.controls.name" type="text">
                    </cll-form-field>
                </div>
                <div>
                    <cll-form-field label="Description" class="w-full">
                        <textarea cllFormInput [formControl]="careTypeFormGroup.controls.description"
                                  type="text"></textarea>
                    </cll-form-field>
                </div>

            </div>
        </cll-card>

        <cll-card>
            <div class="add-new-footer-buttons-container">

                <button cll-button (click)="cancel()">
                    Cancel
                </button>
                <button cll-filled-button colour="secondary" type="submit">
                    <cll-icon cllButtonIcon>check</cll-icon>
                    Create
                </button>
            </div>
        </cll-card>
    </main>
</form>
